import React from "react";
import { CardHeader, Card, CardBody } from "../card/card";

/* -------------------------------
   AlignmentEditor Component
   - Now used solely for previewing the automatically generated alignment.
-------------------------------- */
const AlignmentEditor = ({ alignedComments }) => {
  return (
    <Card>
      <CardHeader><h4>Aligned Comments Preview</h4></CardHeader>
      <CardBody>
      {alignedComments && alignedComments.length > 0 ? (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Text</th>
              <th>Start</th>
              <th>End</th>
            </tr>
          </thead>
          <tbody>
            {alignedComments.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.text}</td>
                {/* Use startS/endS if provided by the API, fallback to start/end */}
                <td>{item.startS || item.start}</td>
                <td>{item.endS || item.end}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No alignment data available.</p>
      )}
      </CardBody>
    </Card>
  );
};

export default AlignmentEditor;
